import React from "react"
import { createRoot } from "react-dom/client"
import ArticleCTA from "../components/article-CTA/article-CTA.component"

// #### MARKDOWN HELPER ####
// This helper function has two main purposes:
// 1. Replace email CTAs with the ArticleCTA component
// 2. Replace old newsletter links with the new URLs
//
// PART 1: Replace email CTAs
// This function replaces email CTAs with the ArticleCTA component.
// In the post body on Contentful, email CTAs are added as divs with the class "email-cta":
// Example:
// <div
//  class="email-cta"
//  data-cta-text="Best articles. Best resources. Only for ZTM subscribers."
//  data-btn-text="Subscribe Now"
//  data-customGtmTags='["BlogPost"]'
//  data-success-response="Great decision, you’ve successfully subscribed!"
//  data-ml-options="BlogPost"
// />
// The ArticleCTA component is a styled component that renders a form for Newsletter signups.



export const replaceEmailCTAs = ({
  key,
  slug,
  tags,
  data,
  isMonthlyPost,
}) => {
  // CREATE AN ARRAY OF THE BLOG POSTS ACTUAL TAGS
  const tagArray = []
  tags && tags.map((tag) => tagArray.push(`tag-${tag.value.toUpperCase()}`))

  // FIND ALL ELEMENTS WITH THE CLASS "email-cta"
  const emailCTAs = Array.from(
    window.document.getElementsByClassName("email-cta")
  )

  // LOOP THROUGH EACH EMAIL CTA AND REPLACE IT WITH THE ARTICLE CTA COMPONENT
  emailCTAs.forEach((element) => {
    // CTA ELEMENTS MIGHT HAVE A DATA ATTRIBUTE FOR CUSTOM GTM TAGS
    // Ideally we would remove this now as it's not needed for GTM
    // However some CTAs are replaced with data from Contentful (New Email CTA)
    // And use this data attribute to identify the correct Contentful entry
    const customGtmTags =
      typeof element.dataset.customgtmtags === "string"
        ? JSON.parse(element.dataset.customgtmtags)
        : element.dataset.customgtmtags

    if (customGtmTags)
      customGtmTags.forEach((cTag) => {
        tagArray.push(`gtmTag-${cTag}`)
      })

    // CREATE A ROOT ELEMENT FOR THE ARTICLE CTA COMPONENT
    const root = createRoot(element)
    root.render(
      React.createElement(ArticleCTA, {
        key,
        slug,
        isTop: element.dataset.top,
        isMiddle: element.dataset.middle,
        tags: tagArray.join(", "),
        label: element.dataset.ctaText
          ? element.dataset.ctaText
          : "Sign up for the Zero To Mastery Newsletter!",
        btnText: element.dataset.btnText
          ? element.dataset.btnText
          : "Subscribe",
        successResponse: element.dataset.successResponse
          ? element.dataset.successResponse
          : "Successfully signed up!",
        data,
        isMonthlyPost: isMonthlyPost,
        datasets: element.dataset,
      }),
      element
    )
  })
  // ##################################
  // #### REPLACE NEWSLETTER LINKS ####
  // ##################################
  // This section looks for anchors in the blog post that link to old URLs for a newsletter page
  // and replaces them with the new URLs. This is to ensure that the links are not broken and
  // marketing don't have to update all the links manually.
  //
  // Examples:
  // Web Development Monthly Newsletter
  // The old links would have been `href="/blog/?tag=WDM#monthly"`
  // The new links are `href="/newsletters/web-development-monthly"`
  //
  // Python Monthly Newsletter
  // The old links would have been `href="/blog/?tag=PM#monthly"`
  // The new links are `href="/newsletters/python-monthly"`
  //
  // Machine Learning Monthly Newsletter
  // The old links would have been `href="/blog/?tag=MLM#monthly"`
  // The new links are `href="/newsletters/machine-learning-monthly"`

  // GET ALL THE ANCHOR ELEMENTS IN THE BLOG POST
  const newsletterLinks = Array.from(window.document.getElementsByTagName("a"))

  // CREATE A NEW LINK ELEMENT - Used in the next step
  const createNewLink = (link, newHref) => {
    const root = createRoot(link)
    root.render(
      React.createElement("a", { href: newHref }, link.innerText),
      link
    )
  }

  // ITERATE OVER THE NEWSLETTER LINKS AND REPLACE THE OLD URLS WITH THE NEW ONES
  newsletterLinks.forEach((link) => {
    const newUrlMap = {
      "?tag=WDM": "/newsletters/web-development-monthly",
      "?tag=PM": "/newsletters/python-monthly",
      "?tag=MLM": "/newsletters/machine-learning-monthly",
    }

    Object.keys(newUrlMap).forEach((oldTag) => {
      if (link.href.includes(oldTag)) {
        createNewLink(link, newUrlMap[oldTag])
      }
    })
  })
}
